<app-alert></app-alert>
<section class="card">

  <div class="card-header">
    <title>Payment of Dividend</title>
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Payment of Dividend</strong>
    </span>

    <span style="float: right">
      <!-- <a routerLink="/paymentOfDividendList"> -->
        <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    <!-- <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button"  *ngIf="!addBtn">
          <span>
            <i class="fa fa-save"></i>Generate Output </span>
        </button>
</span> -->
    <meta charset="utf-8">
  </div>


      <form [formGroup]='podForm' (document:click)="a.close();b.close();c.close();d.close();e.close();f.close()">
          <div class="modal-body">
        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <div _ngcontent-c1="" class="form-group ">
              <label class="form-">Percentage of Dividend Declared</label>
              <input type="text" class="form-control" [formControl]="podForm.controls.percentageOfDividendDeclared">
              <div
              *ngIf="podForm.controls['percentageOfDividendDeclared'].hasError('pattern') && podForm.controls['percentageOfDividendDeclared'].touched"
              class="form-control-error-custom">
              Percentage of Dividend Declared is invalid
            </div>
          
            </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Dividend Rate</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.dividendRate">
            <div
            *ngIf="podForm.controls['dividendRate'].hasError('pattern') && podForm.controls['dividendRate'].touched"
            class="form-control-error-custom">
            Dividend Rate is invalid
          </div>
          </div>

          <div class="form-group  col-md-4 col-sm-6 col-xs-12">
            <label>Date of Book Closure</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="podForm.controls['dateOfBookClosure']"
                [(ngModel)]="DateOfBookClosureModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                name="bookclosuredate" ngbDatepicker #a="ngbDatepicker"
                (click)="a.toggle()">
              <button class="input-group-addon" (click)="a.toggle()"
                type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Record Date</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="podForm.controls['recordDate']" [(ngModel)]="recordDateModel"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="recorddate" ngbDatepicker
                #b="ngbDatepicker" (click)="b.toggle()">
              <button class="input-group-addon" (click)="b.toggle()"
                type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Date of Declaration</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="podForm.controls['dateOfDeclaration']"
                [(ngModel)]="DateOfDeclarationModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                name="declarationdate" ngbDatepicker #c="ngbDatepicker"
                (click)="c.toggle()">
              <button class="input-group-addon" (click)="c.toggle()"
                type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Due Date of Payment of Dividend</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="podForm.controls['dateOfDue']" [(ngModel)]="DateOfDueModel"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="duedate" ngbDatepicker #d="ngbDatepicker"
                (click)="d.toggle()">
              <button class="input-group-addon" (click)="d.toggle()"
                type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Date of Transfer to or Opening of Separate Bank Account</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="podForm.controls['dateOfTransfer']"
                [(ngModel)]="DateOfTransferModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                name="transferdate" ngbDatepicker #e="ngbDatepicker"
                (click)="e.toggle()">
              <button class="input-group-addon" (click)="e.toggle()"
                type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Name of the Member(s)</label>
            <span _ngcontent-c1="" style="color: red;">*</span>
            <!-- <input type="text" class="form-control" [formControl]="podForm.controls.nameOfMembers"> -->
            <select [formControl]="podForm.controls['nameOfMembers']" class="form-control" (change)="getsh2FormDetails($event, podForm.controls.nameOfMembers.value)" style="padding: 6px;"> 
              <option value="">Select any one</option>  
              <option *ngFor="let item of nameOfMemberList; let i = index;" [attr.data-mgt1id]="item.MGT1_id" value="{{item.nameOfMember}}">  
                  {{item.nameOfMember}}
              </option> 
        </select>
            <div
              *ngIf="podForm.controls['nameOfMembers'].hasError('pattern') && podForm.controls['nameOfMembers'].touched"
              class="form-control-error-custom">
              Name of the Member(s) is invalid
            </div>
            <div
              *ngIf="podForm.controls['nameOfMembers'].hasError('required') && podForm.controls['nameOfMembers'].touched"
              class="form-control-error-custom">
              Name of the Member(s) is required
            </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Address/ Registered Address</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.regdAddress" readonly>
            <div
            *ngIf="podForm.controls['regdAddress'].hasError('pattern') && podForm.controls['regdAddress'].touched"
            class="form-control-error-custom">
            Address/ Registered Address is invalid
          </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Folio Number</label>
            <span _ngcontent-c1="" style="color: red;">*</span>
            <input type="text" class="form-control" [formControl]="podForm.controls.folioNo" readonly>
            <div *ngIf="podForm.controls['folioNo'].hasError('required') && podForm.controls['folioNo'].touched"
              class="form-control-error-custom">
              Folio Number is required*.
            </div>
            <div
            *ngIf="podForm.controls['folioNo'].hasError('pattern') && podForm.controls['folioNo'].touched"
            class="form-control-error-custom">
            Folio Number is invalid
          </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Number of Shares held</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.sharesheld" readonly>
            <div
            *ngIf="podForm.controls['sharesheld'].hasError('pattern') && podForm.controls['sharesheld'].touched"
            class="form-control-error-custom">
            Number of Shares held is invalid
          </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Bank Account Number, where the dividend to be credited</label>
            <input type="text" class="form-control" (keydown)="onlyNumber($event)"
              [formControl]="podForm.controls.bankaccountnumber">
            <div
              *ngIf="(podForm.controls['bankaccountnumber'].hasError('minlength') || podForm.controls['bankaccountnumber'].hasError('maxlength')) && podForm.controls['bankaccountnumber'].touched"
              class="form-control-error-custom">
              Bank Account Number is invalid.</div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Address of the Bank Branch, where the dividend to be credited</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.bankAddress">
            <div
            *ngIf="podForm.controls['bankAddress'].hasError('pattern') && podForm.controls['bankAddress'].touched"
            class="form-control-error-custom">
            Address of the Bank Branch, where the dividend to be credited is invalid
          </div>
            
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Amount paid up (Deemed to be paid up) on Shares</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.amountPaid">
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Dividend Amount</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.dividendAmount">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Dividend Warrant Number "From"</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.dividendWarrantFrom">
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Dividend Warrant Number "To"</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.dividendWarrantTo">
          </div>

          <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Serial Numbers of warrants issued from</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.serialNumberofWarrant">
          </div> -->
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Date of Payment of Dividend</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="podForm.controls['dateOfPayment']"
                [(ngModel)]="DateOfPaymentModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                name="paymentdate" ngbDatepicker #f="ngbDatepicker"
                (click)="f.toggle()">
              <button class="input-group-addon" (click)="f.toggle()"
                type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Mode of Payment</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.modeOfPayment">
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Interim Dividend</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.intermDividend">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Final Dividend</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.finalDividend">
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Dividend kept in abeyance</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.dividendAbeyance">
          </div>

          <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Dividend Payable</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.dividendPayable">
          </div> -->

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Name of the Nominee</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.nameOfNominee">
            <div
              *ngIf="podForm.controls['nameOfNominee'].hasError('pattern') && podForm.controls['nameOfNominee'].touched"
              class="form-control-error-custom">
              Name of the Nominee is invalid
            </div>
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Legal Heir</label>
            <input type="text" class="form-control" [formControl]="podForm.controls.legalHeir">
          </div>


          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Remarks, if any </label>
            <textarea class="form-control" [formControl]="podForm.controls.remarks1" maxlength="200"></textarea>
          </div>
        </div>
         
      </div>
        <div class="card-footer" align="right">
            <!--<div class="form-actions" style="text-align: right">-->
        
          <button class="btn btn-sm btn-primary" (click)="showFormEntry()" type="button" [disabled]="!podForm.valid || disabledOnclick"  *ngIf="addBtn">
            <i class="fa fa-save"></i>&nbsp;Save</button>
           
            <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button" *ngIf="!addBtn">
              <span>
                <i class="fa fa-save"></i>Generate Output </span>
            </button> -->


          <button class="btn btn-sm btn-primary" (click)="updateBankAccountParticulars(editPaymentID._id)" type="button"
            [disabled]="!podForm.valid || disabledOnclick" *ngIf="!addBtn">
            <i class="fa fa-save"></i>&nbsp;Update</button>
             <!--</div>--> 
        </div>

      </form>

    
</section>
